import { ShimmerEffect } from "@/components/shimmer";
import { cn } from "utils";
import { useSidebar } from "ui/components/sidebar";
import { StatusDisplay } from "@/components/status/display";
import { TypeDisplay } from "@/components/type/display";
import { JOB } from "icons";
import { Icon } from "components";

/**
 * A collapsible job header component that adapts to sidebar state
 * Shows full header when expanded, only logo when collapsed
 * @param {Object} props - Component props
 * @param {Object} props.job - The job data object
 * @param {string} props.job.status - Job status
 * @param {string} props.job.type - Job type
 * @param {boolean} props.isLoading - Whether the job data is loading
 * @param {string} props.className - Additional CSS classes
 */

export function CollapsibleJobHeader({ job, isLoading = false, className = "" }) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  if (isLoading) {
    return (
      <div className="flex items-center gap-2">
        <ShimmerEffect className="w-30 h-5" />
        <ShimmerEffect className="w-20 h-5" />
      </div>
    );
  }

  if (!job) {
    return null;
  }

  return (
    <div className={cn(className)}>
      {isCollapsed ? (
        <div className="flex items-center gap-2">
          <Icon icon={JOB} size={10} />
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <StatusDisplay value={job.status} />
          <TypeDisplay value={job.type} />
        </div>
      )}
    </div>
  );
}
